<template>

    <div v-if="show || floating" class="page-filters" :class="{ floating: floating }">
        <slot></slot>
    </div>

</template>

<style scoped lang="scss">

    .page-filters {
        align-items: center;
        background: #fff;
        border-bottom: 1px solid $color-rule;
        box-sizing: border-box;
        display: flex;
        flex-shrink: 0;
        height: $header-height;
        justify-content: space-between;
        padding: 10px 15px;
        position: relative;
        *:only-child {
            margin-left: auto;
        }
    }

    .page-filters.floating {
        border: 1px solid $color-rule;
        border-radius: 5px;
        margin-bottom: 10px;
        padding: 10px;
    }

</style>

<script>

export default {

    props: {
        floating: {
            type: Boolean,
            default: false,
        }
    },

    data() {
        return {
            show: false,
        }
    },

    mounted() {
        this.show = false;
        this.$events.$on('pageLoaded', () => {
            this.show = true;
        });
    },

}

</script>
